export default __webpack_public_path__ + "static/media/chip500000.c30bf752.png";